import type { GamificationStats } from '@testflow/shared';
import { useTranslation } from 'react-i18next';

// GAM-2 „gemeinsame Ziele" (Phasen-Fortschrittsbalken) — Design-Spec §3.3 Playlist-Footer.
// Orange-Gradient (`--brand-accent`), NIEMALS Pass-Rate/Geschwindigkeit-zu-grün (GAM-2-Guardrail:
// der einzige Zahlenwert hier ist `team_progress_pct`, ein Fortschritts-, kein Qualitätsmaß).
export function TeamGoalBar({ stats }: { stats: GamificationStats }) {
  const { t } = useTranslation();
  if (!stats.enabled) return null;

  const pct = Math.min(100, Math.max(0, stats.team_progress_pct));

  return (
    <div className="flex flex-col gap-1">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-text-muted">
        {t('gam.teamGoal')}
      </span>
      <div
        role="progressbar"
        tabIndex={0}
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        className="h-2 w-full overflow-hidden rounded-full bg-[var(--bg-subtle)]"
      >
        <div
          className="h-full rounded-full bg-gradient-to-r from-brand-accent-2 to-brand-accent"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
